<template>
    <Modal
        :class="[`DshModal-${mode}`, propsObj.class]"
        :value="showModal"
        :title="propsObj.title || '标题'"
        :closable="propsObj.closable || false"
        :mask-closable="propsObj.maskClosable || false"
        :loading="propsObj.loading"
        :scrollable="propsObj.scrollable"
        :fullscreen="propsObj.fullscreen"
        :draggable="propsObj.draggable"
        :mask="propsObj.mask"
        :footer-hide="propsObj.footerHide === false ? false : true"
        @on-visible-change="visibleChange"
        @on-ok="ok"
        @on-cancel="cancel"
    >
        <div slot="header" class="DshModal-header">
            <slot name="header">
                <div class="ivu-modal-header-inner ">
                    {{ propsObj.title || "标题" }}
                </div>
            </slot>

            <slot name="header-right"></slot>
        </div>

        <!-- 删除按钮 -->
        <Icon
            v-if="propsObj.showSlotClose !== false"
            class="DshModal-close"
            type="md-close"
            size="20"
            @click.native.stop="visibleChange(false)"
        />

        <slot></slot>
    </Modal>
</template>

<script>
    export default {
        name: "DshModal",
        props: {
            value: Boolean,
            mode: {
                type: String,
                default: "default",
                validator: function (value) {
                    return ["small", "default", "middle", "large", "custom"].indexOf(value) !== -1;
                }
            },
            propsObj: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {};
        },
        computed: {
            showModal () {
                return this.value;
            }
        },
        created () {},
        methods: {
            ok (...parmas) {
                this.$emit("ok", ...parmas);
            },
            cancel (...parmas) {
                this.$emit("cancel", ...parmas);
            },
            visibleChange (bool = false) {
                this.$emit("on-visible-change", bool);
                this.$emit("input", bool);
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshModal {
        &-header {
            width: 100%;
            height: 100%;
        }
        &-close {
            padding: 2px;
            position: absolute;
            top: 10px;
            right: 10px;
            cursor: pointer;
        }
    }
</style>
<style lang="less">
    .DshModal-default,
    .DshModal-middle,
    .DshModal-large,
    .DshModal-small {
        .ivu-modal-wrap {
            .ivu-modal {
                padding: 20px;
                margin: auto;
                position: absolute;
                top: 0px;
                bottom: 0px;
                left: 0px;
                right: 0px;
                .ivu-modal-content {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    .ivu-modal-close {}

                    .ivu-modal-header {
                        width: 100%;
                        height: 44px;
                        padding: 10px 40px 10px 16px;
                    }
                    .ivu-modal-body {
                        width: 100%;
                        flex: 1;
                        min-height: 200px;
                        padding: 0px;
                        overflow: auto;
                    }
                    .ivu-modal-footer {
                        width: 100%;
                        height: 50px;
                    }
                }
            }
        }
    }
    .DshModal-default {
        .ivu-modal-wrap {
            .ivu-modal {
                width: 750px !important;
                height: 550px !important;
                max-height: 100%;
                max-width: 100%;
            }
        }
    }
    .DshModal-small {
         .ivu-modal-wrap {
             .ivu-modal {
                width: 500px !important;
                height: 400px !important;
                max-height: 100%;
                max-width: 100%;
            }
        }
    }
    .DshModal-middle {
         .ivu-modal-wrap {
             .ivu-modal {
                width: 1000px !important;
                height: 800px !important;
                max-height: 100%;
                max-width: 100%;
            }
        }
    }
    .DshModal-large {
         .ivu-modal-wrap {
             .ivu-modal {
                width: 80% !important;
                height: 90% !important;
                min-width: 1000px !important;
                max-height: 100%;
                max-width: 100%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/small/DshModal.vue